import { Validators } from "@angular/forms";
import {
  FieldConfig,
  FieldType
} from "../../../../../../shared/components/dynamic-forms-components/field.interface";
import { of } from "rxjs";
import {
  NotificationEscalationLevel
} from "../../../../../../store/entities/warehouse-management/sensor-alert-configuration/sensor-alert-configuration.model";
import {GET_ALL_USER} from "../../../../../../store/entities/user-management/users/users.graphql";
import {User} from "../../../../../../store/entities/user-management/users/users.model";

const escalationLevels = of([
  { id: 1, name: 'First Responder', value: NotificationEscalationLevel.FIRST_RESPONDER },
  { id: 2, name: 'Second Responder', value: NotificationEscalationLevel.SECOND_RESPONDER },
  { id: 3, name: 'Third Responder', value: NotificationEscalationLevel.THIRD_RESPONDER },
  { id: 4, name: 'Fourth Responder', value: NotificationEscalationLevel.FOURTH_RESPONDER },
  { id: 5, name: 'Fifth Responder', value: NotificationEscalationLevel.FIFTH_RESPONDER }
]);

export const sensorAlertConfigFields: FieldConfig[] = [
  {
    type: FieldType.input,
    label: 'Min Temperature',
    key: 'minTemperature',
    inputType: 'number',
    validations: [{ message: 'This field is required', validator: Validators.required, name: 'required' }],
    rowClass: 'col-span-4'
  },
  {
    type: FieldType.input,
    label: 'Max Temperature',
    key: 'maxTemperature',
    inputType: 'number',
    validations: [{ message: 'This field is required', validator: Validators.required, name: 'required' }],
    rowClass: 'col-span-4'
  },
  {
    type: FieldType.input,
    label: 'Min Humidity',
    key: 'minHumidity',
    inputType: 'number',
    validations: [{ message: 'This field is required', validator: Validators.required, name: 'required' }],
    rowClass: 'col-span-4'
  },
  {
    type: FieldType.input,
    label: 'Max Humidity',
    key: 'maxHumidity',
    inputType: 'number',
    validations: [{ message: 'This field is required', validator: Validators.required, name: 'required' }],
    rowClass: 'col-span-4'
  },
  {
    type: FieldType.input,
    label: 'Occurrence Circles',
    key: 'occurenceCircles',
    inputType: 'number',
    validations: [{ message: 'This field is required', validator: Validators.required, name: 'required' }],
    rowClass: 'col-span-4'
  },
  {
    type: FieldType.input,
    label: 'Number of Responders',
    key: 'circlesToEscalation',
    inputType: 'number',
    validations: [{ message: 'This field is required', validator: Validators.required, name: 'required' }],
    rowClass: 'col-span-4'
  },
  {
    type: FieldType.input,
    label: 'Escalation Period (hrs)',
    key: 'escalationPeriod',
    inputType: 'number',
    validations: [{ message: 'This field is required', validator: Validators.required, name: 'required' }],
    rowClass: 'col-span-4'
  },
  {
    type: FieldType.select,
    options: escalationLevels,
    label: 'Escalation Level',
    key: 'level',
    validations: [{ message: 'This field is required', validator: Validators.required, name: 'required' }],
    rowClass: 'col-span-4'
  },
  {
    type: FieldType.paginatedselect,
    label: 'Receiver',
    key: 'receiver',
    query: GET_ALL_USER,
    optionName: 'userFullName',
    optionValue: 'uniqueId',
    multiple: true,
    mapFunction: (user: User) => {
      return {
        ...user,
        userFullName: `${user.firstName} ${user.lastName} (${user.accountType})`,
      }
    },
    validations: [{ message: 'This field is required', validator: Validators.required, name: 'required' }],
    rowClass: 'col-span-4'
  },
  {
    type: FieldType.button,
    label: 'Save',
    rowClass: 'col-span-12'
  }
];